<template>
<div>
	<router-view></router-view>
</div>
</template>

<script>
import "vue2-animate/dist/vue2-animate.min.css";

import * as lib from "@/util/lib.js";


export default {
	name:"simFrameMain",
	data () {
		return {
			stage
		}
	},
	methods:{
	},
	mounted(){
	}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/frame/SIMMain.vue